import { useEffect } from 'react';
import { ENV } from '@src/configs';

const removeInjectedIframe = () => {
  const iframe = document.querySelector(
    'iframe[style*="position: fixed"][style*="z-index: 2147483647"]',
  );
  if (iframe) iframe.remove();
};

const useRemoveInjectedIframe = () => {
  useEffect(() => {
    if (ENV !== 'local') return;

    removeInjectedIframe();

    const observer = new MutationObserver(() => {
      removeInjectedIframe();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, []);
};

export default useRemoveInjectedIframe;
